import agentGetWeChatUserByPhone from "@/api/user/we-chat-user-manage/agentGetWeChatUserByPhone";
import formatPhone from "@/mixin/formatPhoneMixin";
import cardController from "@/api/user/card-manage/cardController";
import agentGetZhifubaoUserByPhone from "@/api/user/we-chat-user-manage/agentGetZhifubaoUserByPhone";
export default {
    data: () => {
        return {
            userLoad: false,
            userList: [],
            card: {
                cardList: {}
            },
            zhifubao: {
                userList:[]
            }
        }
    },
    methods: {
        getUserList(query) {
            if (query !== ''&&query.length>4) {
                query = formatPhone(query)
                this.loading = true;
                agentGetWeChatUserByPhone({
                    phone: query
                }).then(res => {
                    this.userList = res.data;
                    this.userLoad = false;
                    if(this.userList.length===1) {
                        this.selectOne(this.userList[0])
                    }
                })
            } else {
                this.userList = [];
            }
        },
        searchCard(query) {
            if (query !== '' && query.length > 4) {
                this.loading = true;
                cardController.searchCardByCardId({
                    cardId: query
                }).then(res => {
                    this.card.cardList = res.data;
                    this.userLoad = false;
                    if(this.card.cardList.length===1) {
                        this.selectOne(this.card.cardList[0])
                    }
                })
            } else {
                this.card.cardList = [];
            }
        },
        searchZhifubaoUser(phone) {
            if (phone !== '' && phone.length > 4) {
                this.loading = true;
                agentGetZhifubaoUserByPhone({
                    phone: phone
                }).then(res => {
                    this.zhifubao.userList = res.data;
                    this.userLoad = false;
                    if (this.zhifubao.userList.length == 1) {
                        this.selectOne(this.zhifubao.userList[0])
                    }
                })
            } else {
                this.zhifubao.userList = [];
            }
        },
        selectOne(user) {
            this.params.memberId = user.id
            this.$refs.fuzzySearch.blur()
            this.$emit('change', this.params)
            this.$parent.$parent.$parent.$parent.fetchData()
        },
    },
}
